import React from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, CircularProgress } from '@mui/material';
import { useAppData } from '../context/AppDataContext';
import { canAccessGymRoute } from '../utils/gymModules';

export default function RequireGymRoute({ children }) {
  const { gyms, gymsLoading } = useAppData();
  const { pathname } = useLocation();
  let user;
  try { user = JSON.parse(localStorage.getItem('user')); } catch { user = null; }
  if (gymsLoading && user?.role !== 'superadmin') return <CircularProgress aria-label="Loading plan access" />;
  return canAccessGymRoute(user, gyms, pathname) ? children
    : <Alert severity="warning">This page is not included in your gym's selected services or your role. Contact your gym administrator.</Alert>;
}
